import ConsoleLog from './utils/ConsoleLog';

const TAG = 'ParameterStore';

export default class ParameterStore {
  static DYNAMIC_VALUE_FLAG = '@';
  static REGEXP_DYNAMIC_VALUE = /("@(\w+)(|[.]\w+)+")/g;
  static FIELD_SEPARATOR = '.';
  private store: ParameterStoreType;
  constructor() {
    this.store = {};
  }

  register(key: string, data: unknown) {
    if (!key) {
      ConsoleLog.w(TAG, `#register - key argument is not exist.`);
      return;
    }
    if (typeof data === 'undefined') {
      ConsoleLog.w(TAG, `#register - 'Data is not exist. Can not register data in ${key}.`);
      return;
    }

    this.store[key] = data;
    ConsoleLog.d(TAG, `#register - data \n${JSON.stringify(data)}`);
  }

  getRegisteredData(key: string): unknown {
    if (!key) {
      ConsoleLog.w(TAG, `#getRegisteredData - key argument is not exist.`);
      return null;
    }

    if (typeof this.store[key] === 'undefined') {
      ConsoleLog.w(TAG, `#getRegisteredData - has not registered data by "${key}" key.`);
      return null;
    }

    const registeredData = this.store[key];
    ConsoleLog.d(TAG, `#getRegisteredData - registered data \n${JSON.stringify(registeredData)}`);
    return registeredData;
  }

  findValueFromPath(path: string): string | unknown {
    if (!path) {
      ConsoleLog.w(TAG, `#findValueFromPath - path is empty`);
      return;
    }

    const keys = path.replace(/"/g, '').replace(ParameterStore.DYNAMIC_VALUE_FLAG, '').split(ParameterStore.FIELD_SEPARATOR);

    let foundValue = this.store[keys[0]] as object;
    for (let i = 1; i < keys.length; i++) {
      foundValue = foundValue[keys[i] as keyof typeof foundValue];
      if (typeof foundValue === 'undefined') {
        foundValue = {};
        ConsoleLog.w(TAG, `#findValueFromPath - found undefined value ${path} > replaced with an empty object.`);
      }
      ConsoleLog.i(TAG, `#findValueFromPath - found value ${path}/${foundValue}`);
    }

    if (typeof foundValue === 'string') {
      return `"${foundValue}"`;
    }

    if (typeof foundValue === 'object' && Object.keys(foundValue).length > 0) {
      return JSON.stringify(foundValue);
    }
    return foundValue;
  }

  replaceDynamicString(params: string | object): RequestParams {
    let jsonString = JSON.stringify(params);

    jsonString = jsonString.replace(
      ParameterStore.REGEXP_DYNAMIC_VALUE,
      matchedString => {
        const value = this.findValueFromPath(matchedString) as string;
        ConsoleLog.d(TAG, `#replaceDynamicString - replace string ${matchedString} > ${value}`);
        return value;
      }
    );

    return JSON.parse(jsonString);
  }

  // This function doesn't seem to be used.
  // @ts-expect-error ...arg is any
  merge(...arg): object {
    const extended: Record<string, unknown> = {};
    let deep = false;
    let i = 0;
    const length = arg.length;

    // Check if a deep merge
    if (typeof arg[0] === 'boolean') {
      deep = arg[0];
      i++;
    }

    // Merge the object into the extended object
    const merge = (obj: Record<string, unknown>) => {
      for (const prop in obj) {
        // If deep merge and property is an object, merge properties
        if (deep && typeof obj[prop] === 'object') {
          extended[prop] = this.merge(true, extended[prop], obj[prop]);
        } else {
          extended[prop] = obj[prop];
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < length; i++) {
      const obj = arg[i];
      merge(obj);
    }
    return extended;
  }
}
